import axios from "axios";

export const state = {
    loandisbursements: [],
};

export const getters = {
    loandisbursements: (state) => state.loandisbursements,
};

export const mutations = {
    setLoanDisbursements(state, newValue) {
        state.loandisbursements = newValue;
    },
};

export const actions = {
    async fetchLoanDisbursements({ commit, rootState }) {
        const fyear = rootState.financialyears.currentFinancialYear;
        await axios.get(`/loans/disbursements/${fyear}`).then((res) => {
            commit("setLoanDisbursements", res.data.loan_disbursements);
        });
    },
};
